import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/views/payroll/salary-scheme/detail/directive.js';
// 接口地址api
import { getSecuritySetting, setSecuritySetting, setAutoSuspensionResign as _setAutoSuspensionResign, getAutoSuspensionResign as _getAutoSuspensionResign } from 'api/settings';
export default {
  data: function data() {
    var _this = this;
    //  $t('1856', { x: data.resign_date }) : $t('1855') }}
    return {
      options: Array.from({
        length: 31
      }, function (item, index) {
        if (index === 0) return _this.$t('1855');
        return _this.$t('1856', {
          x: index
        });
      }),
      saveLoading: false,
      isEdit: false,
      rules: {
        suspension_day: [{
          required: true,
          message: this.$t('1593')
        }],
        resign_day: [{
          required: true,
          message: this.$t('1593')
        }],
        resign_date: [{
          required: true,
          message: this.$t('1593')
        }]
      },
      data: {
        suspension_login: '',
        watermark: '1',
        is_open: 1,
        // 0 关闭 1开启
        suspension_day: 3,
        // 停职天数
        resign_day: 4,
        // 离职天数
        resign_date: 0 // 离职日期
      }
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$getSecuritySet, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSecuritySetting();
          case 2:
            _yield$getSecuritySet = _context.sent;
            data = _yield$getSecuritySet.data;
            _this2.data = Object.assign(_this2.data, data);
            // 获取自动停职离职
            _this2.getAutoSuspensionResign();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    // 获取自动停职接口
    getAutoSuspensionResign: function getAutoSuspensionResign() {
      var _this3 = this;
      _getAutoSuspensionResign().then(function (res) {
        _this3.data = Object.assign(_this3.data, res.data);
      });
    },
    // 设置自动停职接口
    setAutoSuspensionResign: function setAutoSuspensionResign(_, state) {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.saveLoading = true;
          _setAutoSuspensionResign(_this4.data).finally(function () {
            _this4.saveLoading = false;
          }).then(function () {
            _this4.isEdit = Boolean(state);
          });
        }
      });
    },
    // 取消
    handlerCancel: function handlerCancel() {
      var _this5 = this;
      this.isEdit = false;
      _getAutoSuspensionResign().then(function (res) {
        _this5.data = Object.assign(_this5.data, res.data);
      });
    },
    handlerChange: function handlerChange() {
      this.isEdit = true;
    },
    doSubmit: function doSubmit() {
      setSecuritySetting(this.data).then(function (res) {
        window.location.reload();
      });
    }
  }
};